import { Context, useContext } from 'react';

export function useSafeContext<TContext>(
  context: Context<TContext | undefined>,
  valueName: string,
): TContext {
  const contextValue = useContext(context);

  if (!contextValue) {
    throw new Error(`No ${valueName} context value was provided.`);
  }

  return contextValue;
}
